export default __webpack_public_path__ + "static/end-header-1b1f99e976e792b356f716243858d6e7.png";